import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const paymentDayStatusTagFetchStateSlice = createSlice({
    name: 'paymentDayStatusTagFetchState',
    initialState: {
        dataValid: false,
        inProgress: false,
        statusTag: false,
        isPaymentDayStatusTag: false,
    },
    reducers: {
        setDataValidity(state, action: PayloadAction<boolean>) {
            state.dataValid = action.payload;
        },
        setFetchProgress(state, action: PayloadAction<boolean>) {
            state.inProgress = action.payload;
        },
        setStatusTag(state, action: PayloadAction<boolean>) {
            state.statusTag = action.payload;
        },
        setIsPaymentDayStatusTag(state, action: PayloadAction<boolean>) {
            state.isPaymentDayStatusTag = action.payload;
        },
    },
});

export const paymentDayStatusTagFetchStateReducer = paymentDayStatusTagFetchStateSlice.reducer;
export const paymentDayStatusTagFetchStateActions = paymentDayStatusTagFetchStateSlice.actions;
